/* eslint-disable react/no-array-index-key */
import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  LinearProgress,
  Box,
  DialogContent,
} from '@mui/material';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import XLSXS from 'xlsx-js-style';
import Slide from '@mui/material/Slide';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { Link, useNavigate } from 'react-router-dom';
import '../stylemod.css';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import moment from 'moment';
import axios from '../../axiosConfig';
import '../animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '800',
  backgroundColor: '#e3f2fd',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

const ManageOP = () => {
  // eslint-disable-next-line no-restricted-globals
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const [idToDelete, setidToDelete] = useState(null);
  const [allRecordsData, setallRecordsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);


  const currentDate = new Date();
  const [fromDate, setFromDate] = useState(moment(currentDate).startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment(currentDate).format('YYYY-MM-DD'));
  const [obProduction, setObProduction] = useState(true)

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  useEffect(() => {
    const initializeData = async () => {
      setOpenLoader(true);
      try {
        // First get the control center data
        const controlRes = await axios.instance.get(
          `/GetOneControlCenter/${sessionStorage.getItem('factoryID')}/${sessionStorage.getItem('CompanyId')}`,
          { headers: { Authorization: tokent, 'Content-Type': 'application/json' } }
        );

        const isObProduction = controlRes.data.length > 0 ? controlRes.data[0].OBProduction === 'Y' : false;
        setObProduction(isObProduction);
        getAllOBRecords(isObProduction)
        
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setOpenLoader(false);
      }
    };

    initializeData();
  }, []);

  const getAllOBRecords = async (isObProduction) => {
    setOpenLoader(true);
    try {
      // Convert fromDate and toDate strings to Date objects
      const fromDateObj = fromDate ? new Date(fromDate) : null;
      const toDateObj = toDate ? new Date(toDate) : null;

      const res = await axios.instance.post(
        '/GetAllOtherProcess',
        {
          FromDate: fromDateObj,
          ToDate: toDateObj,
          CompanyId: sessionStorage.getItem('CompanyId'),
          UnitId: sessionStorage.getItem('factoryID'),
          UserId: sessionStorage.getItem('UserID'),
          SplUser: sessionStorage.getItem('SplUser'),
        },
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );

      const filteredData = isObProduction
      ? res.data.filter((item) => item.DepartmentDescription.trim() !== 'Production') 
      : res.data;
      // const filteredData = res.data
      
      setallRecordsData(filteredData);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  // delete Request to delete state
  const deleteRecord = async (admId) => {
    try {
      await axios.instance
        .delete(`/DeleteOtherProcess/${admId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            getAllOBRecords(obProduction);
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Record Deleted, Successfully!');
            setopenAlert(true);
          } else {
            getAllOBRecords(obProduction);
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          // console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting Record:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Record.');
      setopenAlert(true);
    }
  };

  // handleNewRecord
  const handleNewRecord = () => {
    navigate('/dashboard/manage/other_production/add', { state: { isEdit: false, allRecordsData: null } });
  };

  // handle delete popup dialog
  const handleDelete = (admId) => {
    setOpenDelete(true);
    setidToDelete(admId);
  };

  const handleDeleteConfirmed = (admId) => {
    deleteRecord(admId);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleDownloadExcel = () => {
    const data = filteredData.map((enq, index) => ({
      'S.No': index + 1,
      'Process Date': moment(enq.ProcessDate).format('DD-MM-YYYY'),
      'Process Name': enq.DepartmentDescription,
      'Quantity': enq.Quantity,
    }));

    const wb = XLSXS.utils.book_new();
    const ws = XLSXS.utils.json_to_sheet(data, { origin: 'A8' });
    const columns = ['A', 'B', 'C', 'D'];

    const maxColWidths = {};
    const title = 'Other Process Report';

    // SETTING UP WIDTH DYNAMICALLY
    data.forEach((row) => {
      for (const col in row) {
        if (Object.prototype.hasOwnProperty.call(row, col)) {
          const cellValue = row[col] ? row[col].toString() : '';
          maxColWidths[col] = Math.max(maxColWidths[col] || 0, cellValue.length + 7);
        }
      }
    });

    const wscols = Object.keys(maxColWidths).map((col) => ({ wch: maxColWidths[col] }));

    ws['!cols'] = wscols;

    // Merging cells for the title
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 3 } }];

    // Set the title cell's value and styling
    ws.A1 = {
      v: title,
      t: 's',
      s: {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { fgColor: { rgb: '88a3ca' } },
        border: {
          left: { style: 'thin', color: { rgb: '000000' } },
          top: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
        },
      },
    };

    // Add filter dates information
    ws.A3 = {
      v: `From Date: ${fromDate} To Date: ${toDate}`,
      t: 's',
      s: {
        font: { bold: true, sz: 12 },
        fill: { fgColor: { rgb: 'e3f2fd' } },
      },
    };

    // headers row styling
    const headerRowIndex = '8';
    columns.forEach((col) => {
      const cell = `${col}${headerRowIndex}`;
      if (ws[cell]) {
        ws[cell].s = {
          fill: { fgColor: { rgb: '88b0ca' } },
          alignment: { horizontal: 'center' },
          font: { bold: true, sz: 12 },
          border: {
            left: { style: 'thin', color: { rgb: 'black' } },
            top: { style: 'thin', color: { rgb: 'black' } },
            right: { style: 'thin', color: { rgb: 'black' } },
            bottom: { style: 'thin', color: { rgb: 'black' } },
          },
        };
      }
    });

    // excel table contents
    const CellStyle = {
      alignment: { horizontal: 'center' },
      border: {
        left: { style: 'thin', color: { rgb: 'black' } },
        top: { style: 'thin', color: { rgb: 'black' } },
        right: { style: 'thin', color: { rgb: 'black' } },
        bottom: { style: 'thin', color: { rgb: 'black' } },
      },
    };

    for (let i = 1; i <= data.length; i += 1) {
      const rowNumber = i + 8;
      columns.forEach((col) => {
        const cell = `${col}${rowNumber}`;
        if (ws[cell]) {
          ws[cell].s = CellStyle;
        }
      });
    }

    // Add total row
    const totalRow = data.length + 9;
    ws[`A${totalRow}`] = { v: 'Total', t: 's', s: { font: { bold: true }, alignment: { horizontal: 'center' } } };
    ws[`B${totalRow}`] = { v: '', t: 's', s: { font: { bold: true } } };
    ws[`C${totalRow}`] = { v: '', t: 's', s: { font: { bold: true } } };
    ws[`D${totalRow}`] = {
      v: filteredData.reduce((sum, item) => sum + (parseInt(item.Quantity, 10) || 0), 0),
      t: 'n',
      s: {
        font: { bold: true },
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'e3f2fd' } }
      }
    };

    XLSXS.utils.book_append_sheet(wb, ws, 'Other Process Data');

    // Format current date for filename
    const currentDate = moment().format('DD-MM-YYYY');
    XLSXS.writeFile(wb, `Other_Process_Report_${currentDate}.xlsx`);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImagePreviewOpen(true);
  };

  const handleCloseImagePreview = () => {
    setImagePreviewOpen(false);
  };

  // search & filter
  const filteredData = allRecordsData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));

  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: 'linear-gradient(to right, #4e54c8, #8f94fb)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Manage Other Process
            </Typography>
          </Typography>
        </Grid>

        {/* search & add button */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
        >
          <Stack direction={'row'} spacing={1}>
            <TextField
              fullWidth
              size="small"
              label="From Date"
              type="date"
              value={fromDate}
              onChange={handleFromDateChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              fullWidth
              size="small"
              label="To Date"
              type="date"
              value={toDate}
              onChange={handleToDateChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <IconButton color="primary" onClick={() => getAllOBRecords(obProduction)}>
              <PendingActionsIcon />
            </IconButton>
          </Stack>
          <Stack direction={'row'} spacing={2} alignItems={'center'}>
            <TextField
              type="text"
              variant="outlined"
              color="secondary"
              label="Search"
              size="small"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
            <Button
              variant="contained"
              startIcon={<DownloadForOfflineIcon />}
              onClick={handleDownloadExcel}
              color="success"
              title="Download as excel"
              sx={{ color: 'white' }}
            >
              Download
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1, whiteSpace: 'nowrap' }}
              onClick={handleNewRecord}
              endIcon={<ScheduleSendIcon />}
            >
              New Other Process
            </Button>
          </Stack>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ padding: 'none' }}>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="center">Process Date</StyledTableCell>
                <StyledTableCell align="center">Process Name</StyledTableCell>
                <StyledTableCell align="right">Quantity</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((enq, index) => (
                <TableRow key={index} hover>
                  <TableCell align="center" padding="none">
                    {index + 1}
                  </TableCell>
                  <TableCell align="center" padding="normal" >
                    {moment(enq.ProcessDate).format('DD-MM-YYYY')}
                  </TableCell>
                  <TableCell align="center">{enq.DepartmentDescription}</TableCell>
                  <TableCell align="right">
                    {enq.Quantity}
                  </TableCell>
                  <TableCell align="center" padding="normal" sx={{ padding: '0' }}>
                    <Link to={{ pathname: `/dashboard/manage/other_production/edit/${enq.OtherProcessId}` }}>
                      <IconButton aria-label="Edit">
                        <EditIcon color="primary" />
                      </IconButton>
                    </Link>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(enq.OtherProcessId)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* delete confirmation popup dialog box */}
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen={fullScreen}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">{'Are you sure want to Delete?'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={() => handleDeleteConfirmed(idToDelete)} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* Image Preview Dialog */}
      <Dialog open={imagePreviewOpen} onClose={handleCloseImagePreview}>
        <DialogTitle>Preview</DialogTitle>
        <DialogContent>
          <img src={selectedImage} alt="Preview" style={{ maxWidth: '100%', height: 'auto' }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImagePreview} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManageOP;
